import { combineReducers, createAction } from "@reduxjs/toolkit";
import alertDialogReducer from "../toolkit/alertDialog/alertDialogSlice";
import authReducer from "../toolkit/auth/authReducer";
import liveAuctionReducer from "../toolkit/liveAuction/liveAuctionSlice";
import carsInNegotiation from "../toolkit/carsInNegotiation/carsInNegotiationSlice";
import { signupApi } from "../toolkit/auth/signup/signupApi";
import { sellerApi } from "../toolkit/seller/sellerApi";
import { carEstimateApi } from "../toolkit/carEstimate/carEstimateApi";
import carEstimateReducer from "../toolkit/carEstimate/carEstimateSlice";
import { liveAuctionApi } from "../toolkit/liveAuction/liveAuctionApi";
import { myGarageApi } from "../toolkit/myGarage/myGarageApi";
import myGarageSlice from "../toolkit/myGarage/myGarageSlice";
import { sellMyCarApi } from "../toolkit/sellMyCar/sellMyCarApi";
import sellMyCarReducer from "../toolkit/sellMyCar/sellMyCarSlice";
import sellerSidebarReducer from "../toolkit/sidebar/sidebarSlice";
import { signinApi } from "../toolkit/signin/signinApi";
import { upcomingCarsApi } from "../toolkit/upcomingCars/upcomingCarsApi";
import { reducerPaths } from "./reducerPaths";
import { carDetailsApi } from "../toolkit/carDetails/carDetailsApi";
import { carsInNegotiationApi } from "../toolkit/carsInNegotiation/carsInNegotiationApi";
import { vehicleApi } from "../toolkit/vehicle/vehicleApi";
import { contactUsApi } from "../toolkit/contactUs/contactUsApi";
import { geographyApi } from "../toolkit/geography/geographyApi";
import { paypalApi } from "../toolkit/paypal/paypalApi";
import { carfaxApi } from "../toolkit/carfax/carfaxApi";
import { buyNowApi } from "../toolkit/buyNow/buyNowApi";
import { myOrdersApi } from "src/toolkit/myOrders/myOrdersApi";
import { dashboardPaginationFiltersApi } from "src/toolkit/dashboardPaginationFilters/dashboardPaginationFiltersApi";
import { rejectedCarsApi } from "src/toolkit/rejectedCars/rejectedCarsApi";
import { paymentsApi } from "src/toolkit/payments/paymentsApi";

// const persistConfig = {
//   key: "root",
//   storage,
//   whitelist: [],
//   blacklist: [
//     "alertDialog",
//     "sellMyCarDashboard",
//     [signinApi.reducerPath],
//     [sellMyCarApi.reducerPath],
//     [upcomingCarsApi.reducerPath],
//     [signupApi.reducerPath]
//   ]
// };

export const rootReducer = combineReducers({
  [reducerPaths.sidebar]: sellerSidebarReducer,
  [reducerPaths.sellMyCarDashboard]: sellMyCarReducer,
  [reducerPaths.myGarage]: myGarageSlice,
  [reducerPaths.alertDialog]: alertDialogReducer,
  [reducerPaths.auth]: authReducer,
  [reducerPaths.liveAuction]: liveAuctionReducer,
  [reducerPaths.carsInNegotiation]: carsInNegotiation,
  [signinApi.reducerPath]: signinApi.reducer,
  [reducerPaths.sellerApi]: sellerApi.reducer,
  [sellMyCarApi.reducerPath]: sellMyCarApi.reducer,
  [myGarageApi.reducerPath]: myGarageApi.reducer,
  [reducerPaths.vehicleApi]: vehicleApi.reducer,
  [reducerPaths.upcomingCarsApi]: upcomingCarsApi.reducer,
  [reducerPaths.buyNowApi]: buyNowApi.reducer,
  [liveAuctionApi.reducerPath]: liveAuctionApi.reducer,
  [signupApi.reducerPath]: signupApi.reducer,
  [reducerPaths.carEstimateSlice]: carEstimateReducer,
  [reducerPaths.carEstimateApi]: carEstimateApi.reducer,
  [reducerPaths.carDetailsApi]: carDetailsApi.reducer,
  [reducerPaths.carsInNegotiationApi]: carsInNegotiationApi.reducer,
  [reducerPaths.contactUsApi]: contactUsApi.reducer,
  [reducerPaths.geographyApi]: geographyApi.reducer,
  [reducerPaths.paypalApi]: paypalApi.reducer,
  [reducerPaths.carfaxApi]: carfaxApi.reducer,
  [reducerPaths.myOrdersApi]: myOrdersApi.reducer,
  [reducerPaths.rejectedCarsApi]: rejectedCarsApi.reducer,
  [reducerPaths.dashboardPaginationFiltersApi]: dashboardPaginationFiltersApi.reducer,
  [reducerPaths.paymentsApi]: paymentsApi.reducer,
});

// const persistedReducer = persistReducer(persistConfig, rootReducer);
// export default persistedReducer;
